import React from "react";
import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

export const ComingSoon = (): React.JSX.Element => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    py={8.5}
    width="100%"
    bgcolor="white"
  >
    <Typography variant="body-large">
      <strong>Your carrier does not currently provide this data</strong>
    </Typography>
  </Box>
);
